// src/features/production/shortageHold/components/LocationPicker.tsx

import { useLocationsList } from "../api";

interface Props {
  value: string;
  onChange: (locationId: string) => void;
}

const TYPE_LABEL: Record<string, string> = {
  standard: "استاندارد",
  wip_hold: "WIP Hold",
};

export function LocationPicker({ value, onChange }: Props) {
  const { data: locations = [], isLoading } = useLocationsList();

  return (
    <select
      aria-label="Hold Location"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={isLoading}
      style={{
        width: "100%",
        padding: "10px 12px",
        borderRadius: "10px",
        border: "1px solid var(--color-border, #E4DCC8)",
        background: "#FFFFFF",
        color: "#2B2B2B",
        fontSize: "0.9rem",
        outline: "none",
      }}
    >
      <option value="">{isLoading ? "در حال بارگذاری..." : "انتخاب Location (انبار ناقصی)"}</option>
      {locations.map((loc) => {
        const typeLabel = TYPE_LABEL[loc.location_type ?? "standard"] ?? loc.location_type ?? "";
        const physicalTag = loc.is_physical === false ? " — مجازی" : "";
        const namePart = loc.name && loc.name !== loc.code ? ` (${loc.name})` : "";
        return (
          <option key={loc.id} value={loc.id}>
            {loc.code}{namePart} [{typeLabel}{physicalTag}]
          </option>
        );
      })}
    </select>
  );
}
